import { combineReducers } from 'redux';
import gdprData from './gdprData/gdprData.slice';
import mainForm from './mainForm/mainForm.slice';
import initialData from './initialData/initialData.slice';
import ABTest from './ABTest/ABTest.slice';
import test from './test/test.slice';
export var rootReducer = combineReducers({
    ABTest: ABTest,
    gdprData: gdprData,
    initialData: initialData,
    mainForm: mainForm,
    test: test,
});
export default rootReducer;
